
































import Vue, { PropType } from "vue";
import { Project } from '@/api/dto/Corporation';
import { UserProfile } from '@/api/dto/UserProfile';

export default Vue.extend({
  name: 'CorporateTopProjects',
  props: {
    current: String,
    projects: Array as PropType<Project[]>,
  },
  computed: {
  },
  data() {
    return {
      accordionToggleFlag: true,
    }
  },
  methods: {
    isProjectManager(managementUserId: string): boolean {
      let user = this.$store.getters.userProfile as UserProfile;
      if(managementUserId == user.id) {
        return true;
      } else {
        return false;
      }
    },
    accordionToggle() {
      this.accordionToggleFlag = this.accordionToggleFlag == true ? false : true;
    },
    onPushPath(project: Project, dealStatus: string) {
      this.$router.push({ name: "CorpProjectDetail", params: {projectId: project.id, dealStatus: dealStatus} });
    },
  }
})
